import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import NotFound from './pages/NotFound';
import AccessDenied from './pages/AccessDenied';
import {Route,Routes,BrowserRouter as Router,useNavigate, Navigate} from 'react-router-dom';
import {useState,useEffect} from 'react'
import api from './api/login';
import LoginUI from './pages/LoginUI';
import LogOutUI from './pages/LogOutUI';
import ProtectedRoute from './ProtectedRoute';
import Spinner from 'react-bootstrap/Spinner';



import MoreOptions from './pages/MoreOptions';


import NavAdmin from './components/NavAdmin';
import NavStudent from './components/NavStudent';
import UserNav from './components/UserNav';
import HomeAdmin from './pages/HomeAdmin';

import ChangePassword from './pages/ChangePassword';

import ViewAllGSTBillsManager from './pages/ViewAllGSTBillsManager';
import ViewABill from './pages/ViewAGSTBill';
import ViewAGuestHouse from './pages/ViewAGuestHouse';

import ViewAllGSTBillsAdmin from './pages/ViewAllGSTBillsAdmin';
import AdminViewAGSTBill from './pages/AdminViewAGSTBill';
import ViewAllCancelledBills from './pages/ViewAllCancelledBills';

function App() {    
  const [isAuthenticated,setIsAuthenticated]=useState(false); 
  const [isAppLoaded,setIsAppLoaded]=useState(true); 
  const [refreshFailed,setRefreshFailed]=useState(true);
  const [accessToken,setAccessToken]=useState(''); 
  const [loginType,setLoginType]=useState('');
  const [allowedPages,setAllowedPages]=useState([]);
  const [fullName,setFullName]=useState('');
  const [appUserName,setAppUserName]=useState('');

  
  const [currentGuestHouse, setCurrentGuestHouse] = useState("HB");

  const [currentMonth,setCurrentMonth]=useState(''); 
  const [currentYear,setCurrentYear]=useState(''); 


   useEffect(() => {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
      const year = String(today.getFullYear());
    
      setCurrentMonth(month);
      setCurrentYear(year);
    }, []);

  useEffect(()=>{
    const fetchAT=async ()=>{
          try{
            const config = { withCredentials: true };
            const x=await api.get('/getAccessToken',config); 
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            setAccessToken(nat);   
            setAllowedPages(x['data']['allowedPages']); 
            setFullName(x['data']['userFullName']);
            setAppUserName(x['data']['userName']);
            setLoginType(lt);     
            setIsAuthenticated(true);   
            setRefreshFailed(false); 
            }
            catch(err)
            {
              //alert(err);
              setAccessToken('');   
              setLoginType('');   
              setIsAuthenticated(false);  
              setRefreshFailed(true);              
            }
            finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[refreshFailed]);
  return (   
    <Router>
      <div className="App">
      {<Header></Header>}
        { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="admin")&& <NavAdmin
          />}
         { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="student")&& <NavStudent
          />} 
          
          { (isAppLoaded)&&refreshFailed&& <UserNav
          />
          }

        { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="admin")&&
          <>
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                <Route  path='/' element={<HomeAdmin      
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}     
                                       
                          allowedPages={allowedPages}
                          fullName={fullName}
                          currentGuestHouse={currentGuestHouse}
                          setCurrentGuestHouse={setCurrentGuestHouse}
                          currentMonth={currentMonth}
                          setCurrentMonth={setCurrentMonth}
                          currentYear={currentYear}
                          setCurrentYear={setCurrentYear}
                          />}>            
                </Route>
                <Route  path='/changepassword' element={<ChangePassword                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                           appUserName={appUserName}
                          />}>            
                </Route>

                <Route  path='/managergstbills/:billType' element={<ViewAllGSTBillsManager                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                           currentMonth={currentMonth}
                           setCurrentMonth={setCurrentMonth}
                           currentYear={currentYear}
                           setCurrentYear={setCurrentYear}
                          />}>            
                </Route>

                <Route  path='/gstbilldetails/:form_id' element={<ViewABill                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                          />}>            
                </Route>
                <Route  path='/guesthousedetails/:gh_code' element={<ViewAGuestHouse                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                          />}>            
                </Route>
                <Route  path='/admingstbills/:billType/:ghCode' element={<ViewAllGSTBillsAdmin   
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                           currentMonth={currentMonth}
                           setCurrentMonth={setCurrentMonth}
                           currentYear={currentYear}
                           setCurrentYear={setCurrentYear}

                          />}>            
                </Route>

                <Route  path='/cancelledbills/:ghCode' element={<ViewAllCancelledBills   
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}                          

                          />}>            
                </Route>
                
                <Route  path='/gstbilldetailsAdmin/:form_id' element={<AdminViewAGSTBill                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                          />}>            
                </Route>
                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
                
                
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
            <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setRefreshFailed={setRefreshFailed} setGlobalLoginType={setLoginType} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setLoginType={setLoginType} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }
      
      
      
      {
        !isAppLoaded &&
          <div className='spinnerovsetSeerlay'>
            <div className='spinnerbody'>
              <Spinner animation="border" variant="info" />
              <p>Please wait. It might take a few seconds.</p>
            </div>           
          </div>
      }
      {
       (isAppLoaded) && refreshFailed && 
        <>
        <Routes>
        <Route  path='/about' element={<About></About>}></Route>
        <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
          <Route path='*' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
                </Route>

          <Route  path='/login' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}   setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
          </Route>
          <Route  path='/logout' element={ <LogOutUI
          setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>}>            
          </Route>
        </Routes>
        </>
      }

        <Footer></Footer>
      </div>
    </Router>
  );
}

export default App;
